import { AdMob, InterstitialAdPluginEvents, AdLoadInfo, AdOptions, AdmobConsentStatus, RewardAdPluginEvents } from '@capacitor-community/admob'
import { Capacitor } from '@capacitor/core'

export const admobPermissions = async () => {
  const { trackingInfo, consentInfo } = await admobPermissionsGet()
 
  if (trackingInfo.status === 'notDetermined') { 
   await AdMob.requestTrackingAuthorization()
  }

  const authorizationStatus = await AdMob.trackingAuthorizationStatus()

  if (
    authorizationStatus.status === 'authorized' &&
    consentInfo.isConsentFormAvailable &&
    consentInfo.status === AdmobConsentStatus.REQUIRED
  ) {
   await AdMob.showConsentForm()
  }

  const newStatus = await AdMob.trackingAuthorizationStatus()

  return newStatus.status !== 'notDetermined'
}

export const admobPermissionsGet = async () => {
  const [ trackingInfo, consentInfo ] = await Promise.all([
   AdMob.trackingAuthorizationStatus(),
   AdMob.requestConsentInfo()
  ])

  return {
    trackingInfo,
    consentInfo
  }
}

export const admobCanEnable = async () => {
  if (!Capacitor.isPluginAvailable('AdMob')) return false

  return true
}

export async function admobInit(): Promise<void> {
  await AdMob.initialize()
}

export async function resetConsent (): Promise<void> {
  return await AdMob.resetConsentInfo()
}

export async function prepareInterstitial (): Promise<boolean> {
  const options: AdOptions = {
    adId: Capacitor.getPlatform() === 'ios' ? 'ca-app-pub-6623001063710894/8308217233' : 'ca-app-pub-6623001063710894/4721106261'
  }

  await AdMob.prepareInterstitial(options)

  return true
}

export async function displayInterstitial (): Promise<boolean> {
  return new Promise((resolve, reject) => {
    if (!Capacitor.isNativePlatform()) return resolve(false)

    let isLoading = true

    AdMob.addListener(InterstitialAdPluginEvents.Showed, () => {
      isLoading = false
    })

    AdMob.addListener(InterstitialAdPluginEvents.Dismissed, () => {
      resolve(true)
    })

    AdMob.addListener(InterstitialAdPluginEvents.FailedToShow, () => {
      resolve(false)
    })

    setTimeout(() => {
      if (isLoading) resolve(false)
    }, 1000)

    AdMob.showInterstitial()
  })
}

export async function displayRewardVideo (): Promise<boolean> {
  return new Promise(async (resolve, reject) => {
    try {
      if (!Capacitor.isNativePlatform()) return resolve(false)

      await AdMob.prepareRewardVideoAd({
        adId: Capacitor.getPlatform() === 'ios' ? 'ca-app-pub-6623001063710894/7825968447' : 'ca-app-pub-6623001063710894/8899808160'
      })

      let isLoading = true

      AdMob.addListener(RewardAdPluginEvents.Showed, () => {
        isLoading = false
        resolve(true)
      })

      AdMob.addListener(RewardAdPluginEvents.Dismissed, () => {
        resolve(false)
      })

      AdMob.addListener(RewardAdPluginEvents.FailedToShow, () => {
        resolve(false)
      })

      AdMob.addListener(RewardAdPluginEvents.FailedToLoad, () => {
        resolve(false)
      })

      setTimeout(() => {
        if (isLoading) resolve(false)
      }, 2000)
      
      await AdMob.showRewardVideoAd()
    } catch (e) {
      console.error(e)
      resolve(false)
    }
  })
}

